export default __webpack_public_path__ + "static/media/help.d44ce895.svg";